import { ERROR_CODES } from '@/constants/error/errorCode'
import { useApiGw } from '@/features/miiaFw/composables/useApiGw'
import { GlobalError } from '@/utils/globalError/GlobalError'

export const useRequest = () => {
  const { invokeApiGwFunc } = useApiGw()
  function request<T, U>(url: string, path: string, func: string, arg: T) {
    return new Promise<U>((resolve, reject) => {
      invokeApiGwFunc(
        url,
        path,
        {
          function: func,
          params: arg
        },
        // Lambda関数実行前の前処理のコールバック
        () => {},
        // 成功時のコールバック
        (response: U) => {
          resolve(response)
        },
        // 例外受信時のコールバック(引数: エラーメッセージ)
        message => reject(new GlobalError(ERROR_CODES._811010_API_EXECUTION_FAILED, { message })),
        // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
        () => reject(new GlobalError(ERROR_CODES._811010_API_EXECUTION_FAILED)),
        // 処理完了後に実行するコールバック
        () => {},
        // ローディングビュー表示
        false
      )
    })
  }
  return { request }
}
